import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { NumberWithCommas } from "../share/NumberWithCommas";

const ReportUsingMoneyDetailModal = ({ isOpen, toggle, data }) => {
  if (!data) return null;

  // แยก logic แสดงรายละเอียดตาม TypeReport
  const renderDetail = () => {
    switch (data.typeReport) {
      // ---------- ชอ.4-7 ----------
      case "47":
        return (
          <>
            {/* <p><b>ประเภท:</b> ชอ.4-7 ผลการประเมินสมรรถนะ (Knowledge)</p> */}
            <p><b>หน่วยงาน:</b> {data.deptName}</p>
            <p><b>สาขาอาชีพ:</b> {data.lawOccupationName}</p>
            <p><b>ชื่อสาขา:</b> {data.testOccupationName}</p>
            {/* <p><b>ระดับ:</b> {data.stdLevelTname}</p> */}
            <p><b>จำนวนผู้เข้าทดสอบ:</b> {data.personTest}</p>
            <p><b>จำนวนผู้ผ่านการประเมิน:</b> {data.passEvaluation}</p>
            <p><b>วันที่จ่าย:</b> {data.paymentDate}</p>

            <hr />
            <p><b>ค่าใช้จ่าย:</b></p>
            <ul>
              <li>ค่าประเมิน: {NumberWithCommas(data?.evaluatorExpense)}</li>
              <li>ค่าตอบแทน: {NumberWithCommas(data?.compensationExpense)}</li>
              <li>ค่าเดินทาง: {NumberWithCommas(data?.travellingExpense)}</li>
              <li>ค่าวัสดุ: {NumberWithCommas(data?.materialExpense)}</li>
            </ul>
            <p><b>รวม:</b> {NumberWithCommas(data?.paymentAmount)}</p>
            <p><b>สถานะ:</b> {data.supportStatusName}</p>
          </>
        );

      // ---------- ชอ.4-8 ----------
      case "48":
        return (
          <>
            {/* <p><b>ประเภท:</b> ชอ.4-8 ผลการทดสอบมาตรฐานฝีมือแรงงาน (DSD)</p> */}
            <p><b>หน่วยงาน:</b> {data.deptName}</p>
            <p><b>สาขาอาชีพ:</b> {data.lawOccupationName}</p>
            <p><b>ชื่อสาขา:</b> {data.testOccupationName}</p>
            {/* <p><b>ระดับ:</b> {data.stdLevelTname}</p> */}
            <p><b>จำนวนผู้เข้าทดสอบ:</b> {data.personTest}</p>
            <p><b>จำนวนผู้ผ่าน:</b> {data.passTest}</p>
            <p><b>วันที่จ่าย:</b> {data.paymentDate}</p>

            <hr />
            <p><b>ค่าใช้จ่าย:</b></p>
            <ul>
              <li>ค่าตอบแทน: {NumberWithCommas(data.compensationExpense)}</li>
              <li>ค่าเดินทาง: {NumberWithCommas(data.travellingExpense)}</li>
              <li>ค่าวัสดุ: {NumberWithCommas(data.materialExpense)}</li>
            </ul>
            <p><b>รวม:</b> {NumberWithCommas(data.paymentAmount)}</p>
            <p><b>สถานะ:</b> {data.supportStatusName}</p>
          </>
        );

      // ---------- ชอ.4-10 ----------
      case "410":
        return (
          <>
            {/* <p><b>ประเภท:</b> ชอ.4-10 การฝึกอบรมเพื่อรับรองสมรรถนะ (Cert)</p> */}
            <p><b>สาขาอาชีพ:</b> {data.lawOccupationName}</p>
            <p><b>ชื่อหลักสูตร:</b> {data.courseName}</p>
            <p><b>จำนวนผู้เข้าทดสอบ:</b> {data.testingPersonAmount}</p>
            <p><b>จำนวนผู้ผ่าน:</b> {data.passPersonAmount}</p>

            <hr />
            <p><b>ค่าใช้จ่าย:</b></p>
            <ul>
              <li>ค่าผู้สอน: {NumberWithCommas(data.tutorAmountExpense)}</li>
              <li>ค่าอาหารกลางวัน: {NumberWithCommas(data.lunchAmountExpense)}</li>
              <li>ค่าเบเกอรี่: {NumberWithCommas(data.bakeAmountExpense)}</li>
              <li>ค่าสาธารณูปโภค: {NumberWithCommas(data.utilityAmountExpense)}</li>
            </ul>
            <p><b>สถานะ:</b> {data.supportStatusName}</p>
          </>
        );

      // ---------- ชอ.4-9 ----------
      case "49":
        return (
          <>
            {/* <p><b>ประเภท:</b> ชอ.4-9 การประกวดแข่งขันฝีมือแรงงาน (Contest)</p> */}
            <p><b>ชื่อกิจกรรม:</b> {data.detailContest}</p>
            <p><b>ระดับ:</b> {data.detailLevel}</p>
            <p><b>สาขา:</b> {data.detailBranch}</p>
            <p><b>เป้าหมาย:</b> {data.targetPerson}</p>
            <p><b>ดำเนินจริง:</b> {data.targetActual}</p>

            <hr />
            <p><b>งบประมาณ:</b></p>
            <ul>
              <li>งบประมาณจัดสรร: {NumberWithCommas(data.budgetAlloc)}</li>
              <li>งบประมาณใช้จริง: {NumberWithCommas(data.budgetActual)}</li>
            </ul>
            <p><b>สถานะ:</b> {data.supportStatusName}</p>
          </>
        );

      // ---------- ชอ.4-11 ----------
      case "411":
        return (
          <>
            {/* <p><b>ประเภท:</b> ชอ.4-11 โครงการสนับสนุนการดำเนินงาน (Project)</p> */}
            <p><b>ชื่อโครงการ:</b> {data.projectName}</p>
            {data.otherName && <p><b>อื่น ๆ:</b> {data.otherName}</p>}
            <p><b>จำนวนผู้เข้าทดสอบ:</b> {data.testingPersonAmount}</p>
            <p><b>จำนวนผู้ผ่าน:</b> {data.passPersonAmount}</p>

            <hr />
            <p><b>ค่าใช้จ่าย:</b></p>
            <ul>
              <li>ค่าผู้สอน: {NumberWithCommas(data.tutorAmountExpense)}</li>
              <li>ค่าอาหารกลางวัน: {NumberWithCommas(data.lunchAmountExpense)}</li>
              <li>ค่าเบเกอรี่: {NumberWithCommas(data.bakeAmountExpense)}</li>
              <li>ค่าสาธารณูปโภค: {NumberWithCommas(data.utilityAmountExpense)}</li>
              {data.otherAmountExpense && (
                <li>ค่าอื่น ๆ: {NumberWithCommas(data.otherAmountExpense)}</li>
              )}
            </ul>
            <p><b>ยอดรวมทั้งสิ้น:</b> {NumberWithCommas(data.balanceTotalAmount)}</p>
            <p><b>สถานะ:</b> {data.supportStatusName}</p>
          </>
        );

      default:
        return <p>ไม่พบข้อมูลที่ต้องการแสดง</p>;
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>รายละเอียดรายการ</ModalHeader>
      <ModalBody>
        <div className="p-2">{renderDetail()}</div>
      </ModalBody>
    </Modal>
  );
};

export default ReportUsingMoneyDetailModal;
